import Vue from 'vue'
import Vuex from 'vuex'

import mockData from './modules/mockData'
import ga from './modules/ga'
import product from './modules/product'
import shop from './modules/shop'
import ui from './modules/ui'
import user from './modules/user'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    mockData,
    ga,
    product,
    shop,
    ui,
    user
  },
  strict: debug
})



// WEBPACK FOOTER //
// ./src/js/store/index.js